import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { FileText, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";
import { useMemo } from "react";

const normalizarAcao = (acao: string): string =>
    (acao || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim();

const detectaOrientacaoCompletaEditada = (acao: string): boolean => {
    const texto = normalizarAcao(acao);
    
    const temOrientacoesCompletasAlteradas = texto.includes("orientacoes completas alteradas");
    const temEditouOrientacaoCompleta = texto.includes("editou orientacao completa");
    const temEditouOrientacao = texto.includes("editou orientacao");
    const temPrevia = texto.includes("previa");
    
    return temOrientacoesCompletasAlteradas || 
           (temEditouOrientacaoCompleta && !temPrevia) ||
           (temEditouOrientacao && !temPrevia && texto.includes("completa"));
};

const getIconOrientacaoCompletaEditada = (_acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: FileText, color: "var(--c8e44ad)" };
};

export default function CardOrientacaoCompletaEditada({
    item,
    onNavigateToFile,
    isExpanded,
    onToggleExpand
}: CardHistoricoProps) {
    const expandedContent = useMemo(
        () => <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />,
        [item, onNavigateToFile]
    );

    return (
        <CardHistoricoBase
            item={item}
            icon={getIconOrientacaoCompletaEditada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={expandedContent}
        />
    );
}

export const orientacaoCompletaEditadaConfig = {
    tipo: "orientacao_completa_editada",
    detectaTipo: detectaOrientacaoCompletaEditada,
    getIcon: getIconOrientacaoCompletaEditada,
    temExpansao: () => true,
    Component: CardOrientacaoCompletaEditada
};


